export default __webpack_public_path__ + "static/media/Profile_Wendy.da53a230.png";